module.exports = __webpack_public_path__ + "img/8.524a921e.png";